import styled from 'styled-components';

export const Window = styled.div`
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQIW2NkQAKrVq36zwjjgzhhYWGMYAEYB8RmROaABADeOQ8CXl/xfgAAAABJRU5ErkJggg==) repeat;
  margin-bottom: 20px;
  min-height: 400px;
  overflow: auto;

  #image-helper {
    padding: 20px 0;
  }
`;

export const WindowTool = styled.div`
  background-color: #454545;
  color: #ccc;

  &.toolbar {
    input {
      padding: 5px;
      border: 0;
      color: #fff;
      border-radius: 0;
      background-color: #111;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 20px;

  span {
    font-style: italic;
  }
`;

export const HeaderTool = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px 20px;

  div {
    margin-right: 20px;
  }

  span {
    font-style: italic;
  }
`;

export const FileButton = styled.div`
  position: relative;
`;

export const FileButtonUpload = styled.input`
  position: absolute;
  cursor: pointer;
  opacity: 0;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 100%;
`;

export const SendButton = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoBar = styled.div`
  background-color: #ccc;
  color: #666;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;

    svg {
      margin-right: 10px;
    }
  }
`;